export default {
  // ProfilePage.vue
  profilePage: {
    title: 'Mon profil',
    version: 'Version :',

    musicalInformation: {
      subtitle: 'Mes informations musicales',
      myMaterial: 'Mon matériel',
      displayMode: "Mode d'affichage",
      level: 'Niveau',
      learningPath: 'Parcours',
      handSize: 'Taille des mains',
      myVoice: 'Ma voix',
    },

    educationalFollowUp: {
      subtitle: 'Suivi pédagogique',
      myTeacher: 'Mon prof de piano',
      myGoals: 'Mes objectifs',
      scheduledSessions: 'Mes séances programmées',
    },

    accountManagement: {
      subtitle: 'Gestion du compte',
      language: 'Langue de l\'interface',
      newsletterSubscription: 'Abonnement à la newsletter',
      receiveTeacherNotifications: 'Recevoir des notifications du prof',
      passwordChange: 'Changement de mot de passe',
      deleteAccount: 'Suppression du compte',
    },

    legalInformation: {
      subtitle: 'Informations légales',
      termsOfUse: "Conditions générales d'utilisation",
      termsOfSale: 'Conditions générales de vente',
      gdprRequests: 'Autres demandes RGPD',
      contact: 'Contact',
    },

    actions: {
      reviewTutorial: 'Revoir le tutoriel',
      logout: 'Déconnexion',
      cancel: 'Annuler',
      yes: 'Oui',
    },

    deleteAccountDialog: {
      title: 'Suppression du compte',
      question: 'Voulez-vous vraiment supprimer votre compte ?',
      warning: 'Vous disposerez de 14 jours pour récupérer votre compte. Passé ce délai, il ne sera plus possible de le récupérer.',
    },

    notifications: {
      choiceSaved: 'Nous avons bien enregistré votre choix',
      errorOccurred: 'Un problème est survenu, merci de réessayer plus tard...',
      notificationsEnabled: 'Très bien nous vous enverrons des notifications',
      notificationsDisabled: 'Vous ne recevrez plus de notifications',
      goalsSaved: "J'ai pris note de vos nouveaux objectifs !",
    },
  },

  languageSelector: {
    title: 'Langue',
    subtitle: 'Choisir la langue de l\'interface',
    available: 'Langues disponibles',
    changed: 'Langue modifiée avec succès',
  },

  // AccountDeleted.vue
  accountDeletedPage: {
    title: 'Vous avez supprimé votre compte',
    deleted: 'Votre compte à bien été supprimé.Vous disposez de 14 jours pour récupérer votre compte. Passé ce délai, il ne sera plus possible de le récupérer.',
    recovery: 'Pour récupérer votre compte, veuillez vous référer à l\'email que vous avez reçu.',
    contact: 'Nous restons à votre disposition pour toute question.',
    regards: 'Cordialement,',
    team: 'L\'équipe Tokatab',
    backButton: 'Retour',
  },

  // ChangeUserLevelModal.vue
  changeUserLevelModal: {
    title: "Vous pensez que ce niveau n'est pas adapté à votre profil ?",
    description: 'Expliquez nous votre problème, nous allons essayer de vous aider !',
    issueLabel: 'Quel est votre problème ?',
    issueRequired: 'Ce champ est obligatoire',
    detailsPlaceholder: 'Donnez nous plus de détails...',
    detailsRequired: 'Merci de nous donner plus de détails avant de changer votre niveau',
    askForTeacherContact: 'Je souhaite être contacté par un professeur.',
    cancel: 'Annuler',
    changeLevel: 'Je change de niveau',
    issues: {
      tooEasy: 'Trop simple',
      tooHard: 'Trop dur',
      tooLong: 'Trop long',
      notAdapted: 'Inadapté',
    },
    notifications: {
      alreadyMaxLevel: 'Vous êtes déjà au niveau le plus avancé ! Nous alimentons régulièrement notre site avec de nouveaux modules. En attendant vous pouvez vous entrainer en jouant des challenges ou des morceaux !',
      levelIncreased: 'Nous avons changé votre niveau pour le niveau supérieur ! Bon apprentissage !',
      alreadyMinLevel: 'Nous ne pouvons pas vous proposer de contenu plus simple, si vous avez des difficultés, essayez de reprendre les premiers exercices. ',
      alreadyMinLevelWithTeacher: 'Vous avez demandé à être contacté par un professeur, nous allons essayer de vous contacter au plus vite. Surveillez vos emails.',
      alreadyMinLevelNeedMore: 'Pour plus d\'aide, vous pouvez ajouter des informations et demandé à être contacté par un professeur.',
      levelDecreased: 'Nous avons changé votre niveau pour le niveau inférieur ! Bon apprentissage !',
      feedbackTooLong: 'Merci pour votre retour, si vous avez demandé à être contacté, nous essayerons de revenir vers vous ! En attendant vous pouvez essayer les challenges ou les morceaux pour changer un peu !',
      feedbackGeneral: 'Merci pour votre retour, si vous avez demandé à être contacté, nous essayerons de revenir vers vous ! En attendant vous pouvez essayer les challenges ou les morceaux.',
    },
  },

  // SubscribePage.vue
  subscribePage: {
    loadingPrices: 'Chargement des prix...',
  },

  // ProductStep.vue (PlanStep)
  subscribeProductStep: {
    subscribeToTokatab: 'Abonnez vous à Tokatab Premium et révélez tout votre potentiel au piano',
    subscribeButton: 'Voir les offres',
    tagline: 'Révélez tout votre potentiel au piano',
  },

  // ProductCarousel.vue
  subscribeProductCarousel: {
    slide1: {
      title: 'Votre professeur virtuel toujours dans la poche',
      description: 'Une app qui vous comprend, vous accompagne et vous motive pour progresser régulièrement au piano.',
    },
    slide2: {
      title: 'Plus de 1000 exercices et vidéos',
      description: 'Tokatab vous construit un parcours pédagogique 100% personalisé.',
    },
    slide3: {
      title: 'Des challenges pour progresser',
      description: 'Pas le temps pour une longue session ? Nos challenges vous permettront de mettre en application de nouvelles techniques en quelques minutes.',
    },
    slide4: {
      title: 'Nos utilisateurs en parlent mieux que nous !',
      description: "L'application est super motivante. J'avais arrêté le piano, et grâce à Tokatab j'ai retrouvé le plaisir de jouer.",
      author: 'Adèle',
    },
  },

  // PriceStep.vue
  subscribePriceStep: {
    title: 'Grâce à Tokatab Premium',
    desktopTitle: 'Grâce à Tokatab Premium, accédez en illimité à',
    chooseYourPlan: 'Choisissez votre formule',
    perMonth: '/mois',
    perYear: '/ an',
    soit: 'soit',
    oneTime: 'une seule fois',
    billedAnnually: 'facturé {amount}/an',
    richFeatures: {
      f1: { title: 'Tous les morceaux du catalogue', sub: 'Des centaines de morceaux pour tous les niveaux' },
      f2: { title: '1 000+ exercices et vidéos', sub: 'Un parcours pédagogique 100% personnalisé' },
      f3: { title: 'Recommandations personnalisées', sub: 'Des contenus adaptés à votre niveau et vos goûts' },
      f4: { title: 'Feedback MIDI en temps réel', sub: 'Connectez votre piano et recevez un retour instantané' },
      f5: { title: 'Import de vos partitions', sub: 'Travaillez vos propres morceaux directement dans Tokatab' },
      f6: { title: 'Professeur virtuel 7j/7', sub: 'Un coach disponible à tout moment pour vous accompagner' },
    },
    features: {
      unlimited: "Utilisation illimitée de Tokatab",
      features: "Accédez à l'ensemble des fonctionnalités Premium, sans restriction :",
      courses: '<strong>1 000+ exercices</strong>, recommandations personnalisées, morceaux complets, challenges, <strong>révisions guidées</strong>…',
      skills: '👉 gagnez en compétences, à votre rythme.',
      import1: '📁 Import illimité de vos propres partitions',
      import2: '👉 Importez autant de partitions que vous voulez et travaillez-les directement avec Tokatab, étape par étape.',
      community1: "💬 Communauté privée d'abonnés",
      community2: "Accédez à un groupe WhatsApp réservé aux abonnés pour échanger en direct avec l'équipe Tokatab et d'autres <strong>fans de piano.</strong>",
      bullet1: '1 000+ exercices & morceaux complets',
      bullet2: 'Parcours personnalisé & révisions guidées',
      bullet3: 'Importez vos propres partitions',
      bullet4: 'Challenges & compétences',
    },
    cancel: 'Annuler',
    confirm: 'Commencer',
  },

  // PriceCard.vue
  subscribePriceCard: {
    premiumTitle: 'Tokatab Premium',
    bestValue: 'Offre recommandée',
    planTypes: {
      annual: 'Annuel',
      threeMonth: 'Trimestriel',
      lifetime: 'À vie',
      monthly: 'Mensuel',
    },
    subscribeButtons: {
      annual: "S'abonner pour un an",
      threeMonth: "S'abonner pour trois mois",
      lifetime: "S'abonner à vie",
      monthly: "S'abonner pour un mois",
    },
    renewalInfo: {
      annual: 'renouvelé automatiquement tous les ans',
      threeMonth: 'renouvelé automatiquement tous les trimestre',
      monthly: 'renouvelé automatiquement tous les mois',
      lifetime: 'un seul paiement, accès à vie',
    },
  },

  // SubscribeSuccessPage.vue
  subscribeSuccessPage: {
    premiumTitle: 'Tokatab Premium',
    congratulations: 'Félicitations ✨',
    trial: {
      title: "La période d'essai a été activée avec succès !",
    },
    success: {
      title: 'Le paiement est un succès !',
      message: 'Votre abonnement peut mettre quelques minutes pour s\'activer.',
    },
    letsGo: "C'est parti",
  },

  // EarlyAccessPage.vue
  earlyAccessPage: {
    backToHome: "Retour à l'accueil",
    title: 'Bravo !',
    message: "Vous faites partie des <b>toutes premières personnes</b> à avoir cliqué sur ce bouton ! Merci pour votre <b>confiance</b> et votre <b>motivation</b> !<br>L'offre premium de Tokatab sera disponible très prochainement. Nous sommes actuellement en discussion avec les gestionnaires des droits d'auteurs pour rendre cela possible.<br>En attendant, seriez vous intéressé.e à avoir un <b>accès pour une durée limitée</b> à une version test de <b>l'offre premium</b> en tant que <b>testeur.se</b> ? Il reste encore quelques places !<br><br>Si oui, il vous suffit de <b>répondre au questionnaire</b> en cliquant sur le bouton ci-dessous, cela vous prendra 5 minutes max !",
    surveyButton: 'Je répond et profite de Tokatab gratuitement !',
  },

  // TrialModal.vue
  trialModal: {
    trialEnded: {
      title: 'Merci d\'avoir essayé',
      premium: 'Tokatab Premium',
      subtitle: 'Votre période d\'essai est terminée !',
      question: 'Pouvez-vous nous indiquer ce que vous avez pensé de Tokatab ?',
      ratingLabels: {
        dislike: "Je n'ai pas aimé",
        love: "J'ai adoré",
      },
      noOpinion: "Je n'ai pas d'avis",
      validate: 'Valider',
    },
    review: {
      title: 'Merci d\'avoir essayé',
      premium: 'Tokatab Premium',
      highRating: {
        text1: 'Nous sommes ravis que Tokatab vous plaise !',
        text2: 'Au quotidien, nous faisons notre maximum afin de vous fournir la meilleure application pour apprendre le piano.',
        text3: 'De très belles choses sont à venir, nous serions heureux de continuer à vous accompagner dans votre apprentissage.',
      },
      mediumRating: {
        text1: 'Nous sommes ravis que Tokatab vous plaise !',
        text2: 'Au quotidien, nous faisons notre maximum afin de vous fournir la meilleure application pour apprendre le piano.',
        text3: 'De très belles choses sont à venir, nous serions heureux de continuer à vous accompagner dans votre apprentissage.',
        text4: 'Pour cela, nous vous proposons maintenant une offre de -30% sur l\'abonnement annuel.',
      },
      lowRating: {
        text1: 'Oups !! Sortie de route pour l\'équipe Tokatab...',
        text2: 'Nous faisons notre maximum pour construire la meilleure application d\'apprentissage du piano mais il semble que l\'on ait encore du travail pour vous combler.',
        text3: 'Pouvez-vous nous en dire plus sur ce qui vous a déplu ?',
      },
      placeholder: 'Écrivez votre commentaire',
      buttons: {
        subscribe: "S'abonner",
        discount: "Profiter de l'offre -30%",
        continue: 'Continuer',
        discoverPlans: 'Découvrir les formules d\'abonnement',
      },
    },
    reviewSent: {
      thanks: 'Merci pour votre retour.',
      message: 'Nous améliorons continuellement l\'application. Nous vous laissons un accès à une version limitée pour continuer à utiliser Tokatab et constater ces améliorations.',
      continue: 'Continuer',
    },
    extensionRequired: {
      premium: 'Tokatab Premium',
      title: 'Votre période d\'essai est terminée !',
      message: 'Il semble que vous avez peu utilisé Tokatab. Pour que vous puissiez mieux connaître l\'application, nous vous offrons la possibilité d\'étendre votre période d\'essai de {days} jours supplémentaires !',
      subscribe: "S'abonner",
      extend: 'Étendre ma période d\'essai',
    },
  },

  // WaitingSubscriptionModal.vue
  waitingSubscriptionModal: {
    premium: 'Tokatab Premium',
    paymentSucceeded: {
      title: 'Félicitations ! ✨',
      message: 'Le paiement à réussi ! Votre abonnement est activé et vous pouvez dès maintenant profiter de toutes les fonctionnalités de Tokatab.',
    },
    trialEnabled: {
      title: 'Félicitations ! ✨',
      message: 'Votre période d\'essai est activée jusqu\'au {date}. Vous serez débité à cette date, sauf si vous résiliez votre abonnement avant la fin de la période d\'essai depuis votre profil.',
    },
    waiting: {
      text1: 'Vous avez ouvert la page d\'abonnement de Tokatab.',
      text2: 'Si vous avez engagé un processus de paiement et que vous avez validé la transaction via un SMS ou l\'application de votre banque, retournez dans votre navigateur pour finaliser la validation de votre abonnement.',
    },
    close: 'Fermer',
    continue: 'Continuer',
  },

  // SubscriptionService.ts
  subscriptionService: {
    planTypeNames: {
      annual: 'Annuel',
      lifetime: 'À vie',
      monthly: 'Mensuel',
    },
    planTypeUnits: {
      annual: 'par an',
      lifetime: '1 seule fois',
      monthly: 'par mois',
    },
    errors: {
      packageNotFound: "Le package n'existe pas. Veuillez réessayer ou contacter le support.",
      purchaseFailed: "Une erreur est survenue lors de l'achat. Veuillez réessayer ou contacter le support.",
    },
    success: {
      purchaseCompleted: 'Votre achat a bien été effectué !',
    },
  },

  // UserService.ts
  userService: {
    errors: {
      cannotChangeParameter: 'Vous ne pouvez pas changer ce paramètre.',
    },
    freeActionsLimit: {
      daily: {
        message: "Vous avez épuisé votre quota de contenus gratuits aujourd'hui. Abonnez-vous à Tokatab premium pour des contenus illimités !",
        subscribe: "S'abonner",
      },
      weekly: {
        message: 'Vous avez épuisé votre quota de contenus gratuits cette semaine. Abonnez-vous à Tokatab premium pour des contenus illimités !',
        subscribe: "S'abonner",
      },
    },
    updateLevel: {
      notifyText: "Félicitations ! Vous êtes maintenant au niveau {levelName} !",
    }
  },

  // NotificationSessionTypes.ts
  notificationSessionTypes: {
    daysLabel: {
      MON: 'lundi',
      TUE: 'mardi',
      WED: 'mercredi',
      THU: 'jeudi',
      FRI: 'vendredi',
      SAT: 'samedi',
      SUN: 'dimanche',
    },
  },

  // UserConfigurationTypes.ts
  userConfigurationTypes: {
    keyboardTypes: {
      classic: 'Piano non compatible midi',
      midi: 'Piano compatible midi',
      none: 'Pas de piano',
    },
    keyboardTypesWithLabel: {
      acousticPiano: 'Piano acoustique',
      digitalPiano: 'Piano numérique / Synthétiseur',
      midiKeyboard: 'Clavier MIDI',
      noPiano: 'Pas de piano',
    },
    goals: {
      enjoyPlaying: 'Me faire plaisir au piano',
      improveLevel: 'Améliorer mon niveau et développer mon aisance technique',
      discoverNewSongs: 'Découvrir de nouveaux morceaux',
      getBackToPiano: 'Me remettre au piano',
      learnRhythms: "Apprendre les rythmes du piano d'accompagnement",
      playSingSimultaneously: 'Jouer des morceaux et chanter en même temps',
      learnSpecificSong: 'Apprendre un morceau en particulier',
      other: 'Autre',
    },
    displayModes: {
      pianoRoll: 'Piano roll',
      partition: 'Partition',
    },
  },

  // UserLevelsData.ts
  userLevelsData: {
    levels: {
      novice: 'Novice',
      beginner: 'Débutant',
      beginner1: 'Débutant I',
      beginner2: 'Débutant II',
      intermediate: 'Intermédiaire',
      advanced: 'Avancé',
    },
  },

  // LoginPage.vue
  loginPage: {
    errors: {
      invalidCredentials: 'Erreur, vérifiez votre email et mot de passe.',
      incorrectPassword: 'Erreur, votre mot de passe est incorrect.',
      emailAlreadyUsed: 'Cette adresse email est déjà utilisée.',
      signupFailed: "Votre demande d'inscription n'a pas pu aboutir. Vérifiez vos informations et réessayez.\n",
    },
    success: {
      passwordChanged: 'Votre mot de passe à bien été modifié',
    },
    form: {
      emailLabel: 'Votre email',
      passwordLabel: 'Votre mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      loginButton: 'Se connecter',
      or: 'OU',
      noAccount: "Vous n'avez pas encore de compte ?",
      createFreeAccount: 'Créer mon compte gratuitement',
      startUsing: 'Commencez à utiliser Tokatab',
    },
  },

  // ExternalAuthButton.vue
  externalAuthButton: {
    continueWith: 'Continuer avec {provider}',
    errors: {
      genericError: 'Une erreur est survenue',
    },
  },

  // ExternalRegister.vue
  externalRegister: {
    title: 'Confirmer la création de votre compte',
    emailLabel: 'Adresse Mail',
    newsletterConsent: "J'accepte d'être informé de l'actualité de Tokatab par mail (nous détestons le spam autant que vous !)",
    legalNotice: 'En cliquant sur « Confirmer », vous acceptez',
    termsOfUse: 'les Conditions générales d\'utilisation de Tokatab',
    confirmButton: 'Confirmer',
    errors: {
      emailAlreadyUsed: 'Cet email est déjà utilisé pour un autre compte.',
      genericError: 'Une erreur est survenue',
    },
  },

  // ForgotPasswordPage.vue
  forgotPasswordPage: {
    backButton: 'Retour',
    tokatab: 'Tokatab',
    title: 'Vous avez oublié votre mot de passe ?',
    subtitle: 'Veuillez indiquer votre adresse e-mail,<br>nous vous enverrons un lien pour le réinitialiser.',
    emailLabel: 'Votre email',
    sendButton: 'Envoyer',
    errors: {
      invalidEmail: 'Erreur, Veuillez vérifier la saisie de votre email',
    },
    success: {
      emailSent: 'Si un compte lié à cette adresse existe, un email a bien été envoyé à : {email}',
    },
  },

  // ChangePasswordPage.vue
  changePasswordPage: {
    backButton: 'Retour',
    tokatab: 'Tokatab',
    title: 'Choisissez votre nouveau mot de passe',
    newPasswordLabel: 'Nouveau mot de passe',
    confirmPasswordLabel: 'Confirmer le nouveau mot de passe',
    validateButton: 'Valider',
    errors: {
      invalidToken: 'Erreur, le token pour changer votre mot de passe est invalide',
      invalidPassword: 'Erreur, veuillez vérifier la saisie de votre mot de passe',
      passwordRequirements: 'Erreur, votre mot de passe doit contenir au minimum : 8 caractères, 1 majuscule et 1 minuscule',
      passwordMismatch: 'Erreur, les deux mots de passe doivent être identiques',
    },
  },

  // FirebaseAuthenticationService.ts
  firebaseAuthenticationService: {
    errors: {
      loginFailed: 'Une erreur s\'est produite lors de la connexion à {provider}',
    },
  },

  // ValidateEmailPopup.vue
  validateEmailPopup: {
    title: 'Confirmer votre adresse email',
    sentEmail: 'Nous vous avons envoyé un email de validation lors de votre inscription !',
    alreadyValidated: 'Si vous avez déjà validé votre compte, vous pouvez cliquer sur le bouton "Continuer".',
    clickLinkInEmail: 'Sinon, cliquez sur le lien dans l\'email pour valider votre compte, puis revenez sur cette page et cliquez sur le bouton "Continuer".',
    noEmailReceived: {
      label: 'Je n\'ai pas reçu d\'email',
      content: 'Si vous n\'avez pas reçu l\' email de validation, pensez à vérifier vos spam; et si vous avez une adresse Google, regardez dans les onglets "Promotions" ou "Réseaux sociaux". Si vous ne le trouvez pas, vous pouvez cliquer sur le bouton "Renvoyer". Si vous ne l\'avez toujours pas reçu après quelque minutes,',
      contactSupport: 'contactez le support',
    },
    continueButton: 'Continuer',
    resendButton: 'Renvoyer un email',
    resendButtonWithTimer: 'Renvoyer un email ({seconds})',
    errors: {
      emailNotValidated: 'Votre email n\'a pas été validé.',
    },
  },

  // ActivityScore.vue
  activityScore: {
    periodLabel: 'Période d\'analyse',
    periods: {
      allTime: 'Depuis toujours',
      lastThreeMonths: 'Trois derniers mois',
      lastMonth: 'Dernier mois',
    },
    score: 'Score',
    locale: {
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      shortMonths: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
      days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      shortDays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    },
  },

  // ActivityScoreMini.vue
  activityScoreMini: {
    title: 'Score d\'activité',
    messages: {
      connectionHighScore: 'C\'est bien ! Votre régularité est impressionnante !',
      inactivityLongPause: 'Vous avez pris une longue pause, il est temps de se remettre à jouer !',
      inactivityFrequent: 'Vous êtes souvent inactif, je vous conseille d\'être plus régulier pour atteindre vos objectifs !',
      playingTimeHigh: 'Impressionnant ! Vous faites de très bonnes sessions, continuez comme ça.',
      completeLevel: 'Félicitations, vous avez fait d\'énormes progrès ! Votre score monte en flèche.',
      completeModule: 'Vous êtes sur la bonne voie ! Continuez à suivre les cours.',
      completeSkill: 'Vous êtes sur la bonne voie ! Continuez à suivre les cours et débloquer des compétences.',
      completeChallenge: 'Un challenge de plus de complété !',
      completePiece: 'Félicitations, vous savez maintenant jour un morceau de plus !',
      completePiecePart: 'Vous allez bientôt savoir jouer un morceau de plus !',
      completeBadgeGoal: 'Obtenir des badges vous permettra de remplir vos objectifs d\'apprentissage !',
      default: 'Bravo ! Continuez comme ça.',
    },
  },

  // Badges.vue
  badges: {
    title: 'Badges',
    names: {
      regularity: 'Régularité',
      modules: 'Modules',
      pieces: 'Morceaux',
      challenges: 'Challenges',
      profile: 'Profil',
    },
    levels: {
      playThreeTimesWeek: 'Jouez trois fois dans la semaine',
    },
  },

  // UserEventsEnum.ts
  userEvents: {
    CONNECTION: 'Connexion',
    INACTIVITY: 'Inactivité',
    SEARCH: 'Recherche',
    COMPLETE_LEVEL: 'Niveau complété',
    COMPLETE_MODULE: 'Module terminé',
    COMPLETE_VIDEO: 'Vidéo regardée',
    COMPLETE_EXERCISE: 'Exercice complété',
    COMPLETE_CHALLENGE: 'Challenge réussi',
    COMPLETE_PIECE: 'Morceau complété',
    COMPLETE_PIECE_PART: 'Partie finie',
    COMPLETE_SING_PART: 'Partie de chant finie',
    COMPLETE_PIECE_SING: 'Chant terminé',
    COMPLETE_PIECE_CONSOLIDATION: 'Enchaînement réussi',
    COMPLETE_PIECE_SECTION: 'Section terminée',
    COMPLETE_SECTION_STEP: 'Étape complétée',
    COMPLETE_CHECKLIST_STEP: 'Étape de checklist terminée',
    COMPLETE_CHECKLIST: 'Checklist terminée',
    PLAYING_TIME: 'Temps de jeu',
    COMPLETE_SKILL: 'Compétence validée',
  },

  // UserEventTimeline.vue
  userEventTimeline: {
    title: 'Historique',
    weekOf: 'Semaine du',
  },

  // ProgressPage.vue
  progressPage: {
    title: 'Votre progression',
    score: 'Score',
    record: 'Record',
    tooltip: 'L\'objectif est de jouer au moins trois jours chaque semaine !',
    pctOfRecord: '{pct}% du record',
    dashboardObjects: {
      activeWeeks: 'Semaines actives',
      modules: 'Modules',
      pieces: 'Morceaux',
      challenges: 'Challenges',
      skills: 'Compétences',
    },
    noEvents: {
      title: 'Vous pourrez bientôt mesurer ici votre régularité et vos progrès au piano, et je vous partagerai mes analyses pour optimiser votre apprentissage !',
      subtitle: 'Mais pour cela, il faut d\'abord jouer un peu plus.',
      exploreModules: 'Explorer les compétences',
      tryChallenge: 'Essayer un challenge',
      discoverPieces: 'Découvrir les morceaux',
    },
    teacherComments: {
      comment1: [
        'Très impressionnant ! En continuant comme ça vous serez bientôt un virtuose du piano !',
        'Spectaculaire ! Avec cette persévérance, vous deviendrez un pianiste exceptionnel.',
        'Vous progressez admirablement ! Continuez ainsi et vous pourrez apprendre vos morceaux préférés en un rien de temps !',
      ],
      comment2: [
        'Vous êtes sur la bonne voie ! Vous pourriez augmenter un petit peu votre activité hebdomadaire pour accélérer votre apprentissage.',
        'Vos efforts portent leurs fruits ! Si vous augmentez un peu votre temps de jeu chaque semaine, vous progresserez encore plus vite.',
        'Vous pouvez aller encore plus loin ! En augmentant légèrement votre activité, vous verrez des progrès plus rapides dans votre apprentissage.',
      ],
      comment3: [
        'Attention ! Vous êtes entrain de ralentir votre progression, prenez le temps de jouer un peu plus.',
        'Attention à ne pas perdre de vitesse ! Jouez un peu plus souvent pour ne pas ralentir votre apprentissage.',
        'Gardez un œil sur votre rythme. Augmentez votre temps d\'apprentissage pour éviter de ralentir votre progression.',
      ],
      comment4: [
        'Vous faites de formidables progrès ! Continuez comme ça et vous pourrez bientôt jouer vos morceaux favoris !',
        'Votre persévérance paie ! Ne lâchez rien, et vous pourrez bientôt jouer vos morceaux préférés avec aisance.',
        'Vous faites d\'excellents progrès ! Si vous continuez ainsi, vous serez bientôt en mesure de jouer les morceaux que vous adorez.',
      ],
      comment5: [
        'Vos efforts sont en train de payer ! Ne lâchez rien et augmentez un peu la cadence pour optimiser votre apprentissage.',
        'Vous récoltez les fruits de votre travail ! Maintenez cette intensité et augmentez légèrement votre rythme pour maximiser vos progrès.',
        'Continuez à persévérer ! Augmentez légèrement votre activité pour accélérer encore davantage votre apprentissage du piano.',
      ],
      comment6: [
        'Essayez d\'améliorer votre régularité et augmenter votre activité pour accélérer votre apprentissage du piano.',
        'Travailler sur votre régularité et augmenter votre temps de pratique vous aidera à progresser plus rapidement dans l\'apprentissage du piano.',
        'Cherchez à être plus constant dans votre pratique et à augmenter la fréquence de jeu pour accélérer vos progrès.',
      ],
      comment7: [
        'Vous commencez très fort ! Je vois un fort potentiel en vous, continuez ainsi !',
        'Vos débuts sont prometteurs ! Gardez cette énergie, et vous irez loin dans l\'apprentissage du piano.',
        'Vous débutez très bien ! Je vois un potentiel énorme en vous, continuez sur cette lancée !',
      ],
      comment8: [
        'C\'est un bon début ! Augmentez légèrement votre activité pour réaliser une progression optimale !',
        'Vous êtes bien parti ! En augmentant un peu votre activité, vous verrez votre apprentissage s\'accélérer.',
        'Vous avez bien commencé ! Pour une progression optimale, envisagez d\'augmenter légèrement votre temps de pratique.',
      ],
      comment9: [
        'Vous avez encore beaucoup de choses à découvrir ! Suivez les leçons, apprenez des morceaux et défiez vous sur les challenges !',
        'Votre voyage musical ne fait que commencer ! Explorez davantage en suivant les leçons, en apprenant de nouveaux morceaux et en relevant les challenges !',
        'Il y a encore tellement de choses à explorer ! Continuez à suivre les leçons, à maîtriser de nouveaux morceaux et à vous lancer dans d\'autres challenges !',
      ],
    },
  },

  // ActivityScoreRecap.vue
  activityScoreRecap: {
    title: 'Score d\'activité',
    messages: {
      goodSessionWithRegularity: 'Bravo pour votre belle session {date}, continuez comme ça pour faire de bons progrès !',
      goodSessionWithoutRegularity: 'Bravo pour votre belle session {date}, essayez jouer plus régulièrement pour optimiser vos progrès.',
      scoreDecreasedLow: 'Votre score d\'activité a baissé depuis votre dernière session, faisons-le remonter !',
      scoreDecreasedMedium: 'Content de vous revoir ! Essayez de travailler avec Tokatab plus souvent pour faire de bons progrès.',
      scoreDecreasedHigh: 'Content de vous retrouver ! Je vais vous faire progresser au piano après cette longue pause.',
      scoreDecreasedVeryHigh: 'Vous avez pris une longue pause, vous avez de la chance j\'ai encore des créneaux !',
      smallBreak: 'Content de vous revoir ! Vous avez pris une petite pause, mais rien de grave, nous allons continuer à travailler !',
      completeLevel: 'Félicitations, vous avez passé un cap important en validant un niveau !',
      completePiece: 'Félicitations, c\'était un plaisir de vous faire travailler un morceau en entier. N\'hésitez pas à nous envoyer une vidéo de vous en train de le jouer.',
      completeModulesPlural: 'Bravo pour les derniers modules validés. Continuons sur cette lancée.',
      completeModuleSingular: 'Bravo pour le dernier module validé. Continuons sur cette lancée.',
      completeSkillsPlural: 'Bravo pour les dernières compétences validées. Continuons sur cette lancée.',
      completeSkillSingular: 'Bravo pour la dernière compétence validée. Continuons sur cette lancée.',
      completeChallengesAndParts: 'Bravo, vous avez complété {challenges} et {parts}. Continuez comme ça !',
      completeChallengesAndSections: 'Bien joué, vous avez complété {challenges} et {sections}.',
      completeChallengesAndExercises: 'Bien joué, vous avez complété {challenges} et {exercises}.',
      completePartsAndExercises: 'Ouah, belle session ! Vous avez complété {parts} et {exercises}. Continuez comme ça !',
      completeParts: 'Content de travailler un morceau avec vous ! {parts} complétée(s) en plus. Continuez comme ça !',
      completeSectionsAndExercises: 'Ouah, belle session ! Vous avez complété {sections} et {exercises}. Continuez comme ça !',
      completeExercises: 'Très bien ! Vous avez complété {exercises}. Continuez comme ça !',
      completeSections: 'Très bien ! Vous avez complété {sections}. Continuez sur cette lancée !',
      completeChallenges: 'Super ! Vous avez complété {challenges}.',
      playingTimeHigh: 'Très belle session ! Vous avez bien travaillé, continuez comme ça.',
      playingTimeRegular: 'Continuez comme ça et vous allez vous améliorer.',
      connectionHighScore: 'C\'est bien ! Votre régularité est impressionnante !',
      default: 'Bravo ! Continuez comme ça.',
      challenge: '{count} challenge',
      challenges: '{count} challenges',
      exercise: '{count} exercice',
      exercises: '{count} exercices',
      part: '{count} partie',
      parts: '{count} parties',
      section: '{count} section',
      sections: '{count} sections',
    },
  },

  // Components partagés
  profileSettings: {
    save: 'Enregistrer',
    
    // MySubscriptionSetting.vue
    subscription: {
      title: 'Mon abonnement',
      yourSubscription: 'Votre Abonnement',
      viaAppStore: "Via l'App Store",
      appStoreManagement: "Rendez-vous dans l'App Store pour gérer votre abonnement ou contactez notre support :",
      type: 'Type :',
      price: 'Prix :',
      premiumMemberSince: 'Membre premium depuis le',
      alphaBetaMemberSince: 'Membre alpha/beta depuis le',
      trialEndDate: "Fin de la période d'essai le",
      noActivePremium: 'Aucun abonnement premium en cours',
      restorePurchases: 'Restaurer les abonnements',
      subscribe: "S'abonner",
      manageSubscription: 'Gérer mon abonnement',
      weeklyFreeActionsRemaining: 'Il vous reste {count}/{total} contenus cette semaine.',
      dailyFreeActionsRemaining: "Il vous reste {count}/{total} contenus pour aujourd'hui.",
      weeklyFreeTeacherMessagesRemaining: 'Il vous reste {count}/{total} messages avec le prof cette semaine.',
      subscriptionRestored: 'Abonnement restauré avec succès !',
      noActiveSubscriptionFound: "Aucun abonnement actif n'a été trouvé, un problème ? Contactez le support.",
    },

    // GoalPickerSetting.vue
    goals: {
      title: 'Mes objectifs',
    },

    // SelectMaterialSetting.vue
    material: {
      title: 'Mon matériel',
      updated: 'Votre matériel a bien été mis à jour',
    },

    // SelectDisplayModeSetting.vue
    displayMode: {
      title: "Mode d'affichage",
      updated: "Votre mode d'affichage a bien été mis à jour",
    },

    // LevelSetting.vue
    level: {
      title: 'Niveau',
      currentLevel: 'Pour l\'instant vous avez le niveau :',
      changeLevel: 'Changer le niveau',
      retakeTest: 'Repasser le test de niveau',
    },

    // HandSizeSetting.vue
    handSize: {
      title: 'Taille des mains',
      notTested: "Vous n'avez pas encore passé le test.",
      takeTest: 'passer le test',
      retakeTest: 'repasser le test',
    },

    // SingerProfileSetting.vue
    voice: {
      title: 'Ma voix',
      myVoice: 'Ma Voix',
      notTested: "Vous n'avez pas encore passé le test !",
      singerNotice: "N'hésitez pas à mesurer votre tessiture avec notre test pour que Tokatab puisse vous proposer par la suite les morceaux dans une tonalité adaptée à votre voix.",
      takeTest: 'Passer le test',
      retakeTest: 'Repasser le test',
      voiceTypes: {
        bass: 'Basse',
        baritone: 'Baryton',
        tenor: 'Tenor',
        alto: 'Alto',
        mezzo: 'Mezzo',
        soprano: 'Soprano',
      },
    },

    // SessionNotificationsSetting.vue
    scheduledSessions: {
      title: 'Séances programmées',
      subtitle: '',
      description1: 'Nous pensons que une des clés pour progresser est la régularité !',
      description2: 'C\'est pourquoi vous pouvez programmer des rappels pour vos séances de piano !',
    },

    // SelectCapgoChannel.vue
    capgoChannel: {
      title: 'Change capgo channel',
      error: 'Erreur dans le changement de canal.',
    },
  },

  // SubscriptionButton.vue
  subscriptionButton: {
    tryTokatabPremium: 'Essayer Tokatab Premium',
    tokatabPremium: 'Tokatab Premium',
  },
}